if (!customElements.get("sticky-offer-bar")) {
  customElements.define(
    "sticky-offer-bar",
    class StickyOfferBar extends HTMLElement {
      constructor() {
        super();
        this._onScroll = this._onScroll.bind(this);
        // Two independent conditions, combined in _update():
        this.scrolledPast = false; // user scrolled past the reveal threshold
        this.footerVisible = false; // footer has entered (or is near) the viewport
      }

      connectedCallback() {
        this.revealAfterFold = this.hasAttribute("data-reveal-after-fold");
        this.threshold = parseInt(this.dataset.revealAfter, 10) || 0;

        // Hide the bar once the footer comes into view so the two never overlap.
        this._observeFooter();

        // In the theme editor, keep the bar revealed (ignore the scroll
        // threshold) so merchants can see/edit it — but still let it hide at
        // the footer via the observer above.
        if (window.Shopify && Shopify.designMode) {
          this.scrolledPast = true;
          this._update();
          return;
        }

        // No threshold → always "scrolled past"; otherwise track scroll position.
        if (!this.revealAfterFold && this.threshold <= 0) {
          this.scrolledPast = true;
          this._update();
        } else {
          window.addEventListener("scroll", this._onScroll, { passive: true });
          this._onScroll();
        }
      }

      disconnectedCallback() {
        window.removeEventListener("scroll", this._onScroll);
        this._footerObserver?.disconnect();
      }

      _observeFooter() {
        const footer = document.querySelector(".footer");
        if (!footer || !("IntersectionObserver" in window)) return;

        this._footerObserver = new IntersectionObserver(
          (entries) => {
            this.footerVisible = entries[0].isIntersecting;
            this._update();
          },
          // rootMargin controls how early the bar hides as the footer
          // approaches. A positive bottom margin starts hiding sooner so the
          // pill never visually touches the footer.
          { rootMargin: "0px 0px 120px 0px" },
        );
        this._footerObserver.observe(footer);
      }

      _onScroll() {
        // Fold mode reveals at 75% of the viewport height, just before the
        // first screen ends. Read live so it follows resizes and the mobile
        // URL bar collapsing.
        const threshold = this.revealAfterFold
          ? window.innerHeight * 0.75
          : this.threshold;
        this.scrolledPast = window.scrollY > threshold;
        this._update();
      }

      _update() {
        this.classList.toggle(
          "is-visible",
          this.scrolledPast && !this.footerVisible,
        );
      }
    },
  );
}
